import {createLogger} from '../../common/logging.config';
const logger = createLogger('shutterstock-service');

module.exports = ['$http', '$q', function($http, $q) {

	const enabledURL = '/api/shutterstock/v1/enabled?detail=entitlement';

    /**
	* Returns a promise to the JSON if Shutterstock service is available for current tenant. If it is enabled, it will return the license and usage of shutterstock account
	* @param null
	* @return {Promise}
	*/
    // return the license and usage of shutterstock
	function getShutterstockEnabled() {
		return $http.get(enabledURL).then(
			(res) => res.data,
			(res) => $q.reject(res.status + ' :: ' + res.statusText),
			(err) =>{
				logger.error(err);
			}
		);
	}

	
	// return public API for the REST factory
    return {
        getShutterstockEnabled: getShutterstockEnabled
    };
}];



// WEBPACK FOOTER //
// ./app/common/services/shutterstock-service.factory.js